<ng-container *transloco="let t">
    <mat-nav-list>
        <a mat-list-item (click)="onSidenavClose(); navigation('provider')">
            <span class="nav-caption">{{
                t("shared.link.find-a-provider") | uppercase
            }}</span>
        </a>
        <a
            mat-list-item
            (click)="onSidenavClose(); navigation('help-and-support')"
        >
            <span class="nav-caption">{{
                t("shared.link.help-and-support") | uppercase
            }}</span>
        </a>
        <a mat-list-item (click)="signIn()" *ngIf="!isSignedIn">
            <span class="nav-caption">{{
                t("shared.link.sign-in") | uppercase
            }}</span>
        </a>
        <ng-container *ngIf="isSignedIn">
            <button mat-button [matMenuTriggerFor]="userMenu">
                {{ (user$ | async)?.displayName }}
            </button>
            <mat-menu #userMenu="matMenu">
                <button
                    mat-menu-item
                    (click)="navigation('account')"
                    class="account-button"
                >
                    {{ t("shared.link.my-account") | uppercase }}
                </button>
                <button
                    mat-menu-item
                    (click)="signOut()"
                    class="account-button"
                >
                    {{ t("shared.link.sign-out") | uppercase }}
                </button>
            </mat-menu>
        </ng-container>
        <button mat-button [matMenuTriggerFor]="menu" class="language-dropdown">
            <mat-icon>language</mat-icon>
            <span> {{ selectedLanguageName | uppercase }} </span>
            <mat-icon>expand_more</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
            <button
                mat-menu-item
                *ngFor="let language of languages"
                (click)="selectLanguage(language.code)"
            >
                {{ language.name }}
            </button>
        </mat-menu>
    </mat-nav-list>
</ng-container>
